import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import SavedPaymentMethod from "~/types/SavedPaymentMethod"
import { apiSavedPaymentMethods } from "~/routes"

type PayableType = "booking" | "sponsorship" | "deal"

interface SavedPaymentMethodsResponse {
  status: string
  savedPaymentMethods: SavedPaymentMethod[]
}

const useSavedPaymentMethods = (payableType: PayableType, payableId?: string) => {
  const { venueSlug } = getAppConfig()

  const endpoint = payableId
    ? apiSavedPaymentMethods.index.path({
      venue_slug: venueSlug,
      payable_type: payableType,
      payable_id: payableId,
    })
    : ""

  const { data, ...rest } = useFetchResource<
    SavedPaymentMethodsResponse,
    "savedPaymentMethods"
  >(endpoint, "savedPaymentMethods")

  return {
    savedPaymentMethods: payableId ? data : [],
    ...rest,
  }
}

export default useSavedPaymentMethods
